import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { FILTER_BG_COLOR, FILTER_TAG_COLOR, FILTER_TEXT_COLOR } = constants;

let styles = {
  base: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    width: '100%',
    backgroundColor: FILTER_BG_COLOR,
    height: 30,
    padding: '0 6px',
    boxSizing: 'border-box'
  },
  bar: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    boxSizing: 'border-box',
    overflow: 'hidden',
    marginBottom: -15
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    height: 24,
    backgroundColor: FILTER_TAG_COLOR,
    color: FILTER_TEXT_COLOR,
    textTransform: 'uppercase',
    fontSize: '0.9em',
    fontWeight: 600,
    borderRadius: 100,
    padding: '0 15px',
    marginRight: 5,
    marginTop: 3,
    whiteSpace: 'nowrap'
  },
  remove: {
    color: FILTER_TEXT_COLOR,
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 5,
    marginTop: 2,
    cursor: 'pointer'
  },
  left: {
    marginRight: 5
  },
  right: {
    marginLeft: 5
  },
  hide: {
    display: 'none'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/filterbar/FilterBar.styles.js